<template>
    <v-select
            :items="documents"
            :label="label"
            :rules="rules"
            v-model="value"
            outline
    ></v-select>
</template>

<script>

    import utils from '../utils';

    export default {
        name: "OrderDocument",
        props: {
            label: {
                type: String,
                default: 'Dokument'
            },
            value: {
                type: String,
                default: '1'
            },
            rules: {
                default: []
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        data: vm => ({
            documents: utils.orderDocuments
        })
    }
</script>

<style scoped>

</style>